import { ChangeDetectorRef, Component, Injectable, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule, NgbDateStruct, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../../custom-landing.module';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ShipmentVmsEblBlComponent } from '../../shipment-vms-ebl-bl/shipment-vms-ebl-bl.component';
import { I18nModule, TranslationService } from '@spartacus/core';
import { CustomProductsService } from '../../../custom-products/custom-products.service';
import { pairwise } from 'rxjs';
import { AttachInvoiceComponent } from '../../attach-invoice/attach-invoice.component';

interface AnalysisFormData {
  documents?: any[];
  reportingDate: any;
  startDate: any;
  endDate: any;
  nbslQuantity: any;
  nbsfQuantity:any;
  nbslTotalFe: any;
  nbslSilica: any;
  nbslAlumina: any;
  nbsfTotalFe: any;
  nbsfSilica: any;
  nbsfAlumina: any;
  nbslPhosphorus:any;
  nbslSulfur:any;
  nbslLossOnIgnition:any;
  nbslMoistureContent:any;
  nbsfPhosphorus:any;
  nbsfSulfur:any;
  nbsfLossOnIgnition:any;
  nbsfMoistureContent:any;
  oversize31p5Mm: any;
  oversize25Mm: any;
  oversize20Mm: any;
  undersize6p3Mm: any;
  oversize15Mm: any;
  oversize10Mm: any;
  oversize8Mm: any;
  oversize6p3Mm_nbsl: any;
  oversize6p3Mm: any;
  oversize4Mm: any;
  oversize1Mm:any;
  oversize0p5Mm:any;
  oversize0p25Mm:any;
  oversize0p15Mm:any;
  minus0p15Mm:any;
  remarks: any;
  files?: any[];
}

interface Lot {
  hasEntry: boolean;
  lotFormData: AnalysisFormData;
}
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? ('0' + date.day).slice(-2) + this.DELIMITER + ('0' + date.month).slice(-2) + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? ('0' + date.day).slice(-2) + this.DELIMITER + ('0' + date.month).slice(-2) + this.DELIMITER + date.year : '';
  }
}
@Component({
  selector: 'app-quality-insp-details',
  standalone: true,
  imports: [
   SharedModule, CustomLandingModule, CommonModule, RouterModule, FormsModule, ReactiveFormsModule,NgbModule,NgbDatepickerModule,I18nModule
  ],
  templateUrl: './quality-insp-details.component.html',
  styleUrl: './quality-insp-details.component.scss',
   providers: [
      { provide: NgbDateAdapter, useClass: CustomAdapter },
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ]
})
export class QualityInspDetailsComponent implements OnInit {

  enableLoader: boolean = false;
  productCode: any;
  id: any;
  queryParamsData: { [key: string]: any } = {};
  currentTab: string = 'Active';
  /** Header / summary data */
  details: any;

  attachments: any[] = [];
  adminRemarks: any;

  /** Lot management */
  lots: Lot[] = [];
  selectedLotIndex = 0;

  /** Quality completed toggle */
  qualityCompleted: boolean | null = false;

  /** NBSL / NBSF toggle */
  analysisType: 'NBSL' | 'NBSF' = 'NBSL';

  /** File upload */
  fileArray: any[] = [];
  uploadErr = false;

  /** Reactive form */
  analysisForm!: FormGroup;
  isSubmitted = false;
  formData:any;
  showEditButton = false;  
  currentLotData:any;
  fileLoading= false;
  isAgentInvoiceActive: string = 'false';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public formatter: NgbDateParserFormatter,
    private customProfileService: CustomProfileService,
    private toastrService: ToastrService,
    public modalService: NgbModal, 
    private translationService: TranslationService,
     private cd: ChangeDetectorRef,
     private customProductService:CustomProductsService
  ) {}

  getDefaultFormData(): AnalysisFormData {
    return {
      reportingDate: null,
      startDate: null,
      endDate: null,
      nbslQuantity: null,
      nbsfQuantity:null,
      nbslTotalFe: null,
      nbslSilica: null,
      nbslAlumina: null,
      nbsfTotalFe: null,
      nbsfSilica: null,
      nbsfAlumina: null,
      nbslPhosphorus:null,
      nbslSulfur:null,
      nbslLossOnIgnition:null,
      nbslMoistureContent:null,
      nbsfPhosphorus:null,
      nbsfSulfur:null,
      nbsfLossOnIgnition:null,
      nbsfMoistureContent:null,
      oversize31p5Mm: null,
      oversize25Mm: null,
      oversize20Mm: null,
      undersize6p3Mm: null,
      oversize15Mm: null,
      oversize10Mm: null,
      oversize8Mm: null,
      oversize6p3Mm_nbsl: null,
      oversize6p3Mm: null,
      oversize4Mm: null,
      oversize1Mm:null,
      oversize0p5Mm:null,
      oversize0p25Mm:null,
      oversize0p15Mm:null,
      minus0p15Mm:null,
      remarks: null,
      files: [],
      documents: []

    };
  }

  ngOnInit(): void {
     this.customProductService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })
    this.enableLoader = true;
     this.id = this.route.snapshot.paramMap.get('id');
     this.productCode =  this.route.snapshot.paramMap.get('code');
    // this.route.queryParams.subscribe((params:any) => {
    //   this.queryParamsData = params || {};     
    //   this.currentTab = this.queryParamsData['tab'] || 'Active';
    
    // });
     this.queryParamsData = this.route.snapshot.queryParams || {};
     this.currentTab = this.queryParamsData['tab'] || 'Active';
    this.getQualityInspectionDetails();
           this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
              this.enableLoader = true;
              if (current != null) {
                if (previous !== current) {
                  this.getQualityInspectionDetails();
                }
              }
            })
    this.analysisForm = this.fb.group({
      reportingDate: [null, [Validators.required]],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      nbslQuantity: [null, [Validators.required]],
      nbsfQuantity:[null, [Validators.required]],
      nbslTotalFe: [null],
      nbslSilica: [null],
      nbslAlumina: [null],
      nbsfTotalFe: [null],
      nbsfSilica: [null],
      nbsfAlumina: [null],
      nbslPhosphorus:[null],
      nbslSulfur:[null],
      nbslLossOnIgnition:[null],
      nbslMoistureContent:[null],
      nbsfPhosphorus:[null],
      nbsfSulfur:[null],
      nbsfLossOnIgnition:[null],
      nbsfMoistureContent:[null],
      oversize31p5Mm: [null],
      oversize25Mm: [null],
      oversize20Mm: [null],
      undersize6p3Mm: [null],
      oversize15Mm: [null],
      oversize10Mm: [null],
      oversize8Mm: [null],
      oversize6p3Mm_nbsl: [null],
      oversize6p3Mm: [null],
      oversize4Mm: [null],
      oversize1Mm:[null],
      oversize0p5Mm:[null],
      oversize0p25Mm:[null],
      oversize0p15Mm:[null],
      minus0p15Mm:[null],
      remarks: [null, [Validators.maxLength(1000)]],
    }, { validators: this.dateRangeValidator });
    
  }

  getQualityInspectionDetails(){
this.lots =[];
    const code = this.productCode;
    this.customProfileService.getQualityInspectionDetails(code).subscribe((response:any) => {
      // console.log('Quality Inspection Details:', response);
      this.details = response;
      if(this.details && this.details.lots && this.details.lots.length > 0){
        let lastLot= this.details.lots[this.details.lots.length - 1];
        this.attachments = lastLot.documents || [];
        this.details.lots.forEach((lot: any) => {
          this.addLot(lot);
        });
      }else{
        this.addLot(''); // Add at least one lot if none exist
      }
      if(this.details.status === 'COMPLETED' ){
        this.qualityCompleted = true;
      }
    },(error:any) => {
      this.translationService.translate('quality.failedQualityInspectionDetails').subscribe(res=>{
        this.toastrService.show(res);
      });
    });
  }

  backToList(): void {
    this.router.navigate(['/shipmentvms/quality-inspection'], { queryParams:{from:'details', tab: this.currentTab}, skipLocationChange: false });
  }

  setQualityCompleted(value: boolean): void {
    this.qualityCompleted = value;
    if(this.qualityCompleted == true && this.details.lots.length > 0){
       const modalRef = this.modalService.open(ShipmentVmsEblBlComponent, { centered: true, size: 'md' });
                  modalRef.componentInstance.shipData = this.details;
                  modalRef.componentInstance.modalToOpen = 'qualityCompleted';
                  modalRef.componentInstance.flag = this.qualityCompleted;   
                  modalRef.result.then(res=>{
                    if(res=='success'){
                      this.router.navigate(['/shipmentvms/quality-inspection'], { queryParams:{tab:'Completed'} });
                    }else if(res=='close'){
                     this.qualityCompleted = false;    
                    }
                  })
    }else{
      this.qualityCompleted = false;  
      this.translationService.translate('quality.completeInspectionDetails').subscribe(res=>{
        this.toastrService.show(res);
      });
    }
  }

  setAnalysisType(type: 'NBSL' | 'NBSF'): void {
    if (this.analysisType === type) return;
    
    // Save current form data before switching
    this.saveCurrentFormData();
    
    // Switch analysis type
    this.analysisType = type;
    
    
    // Load form data for new analysis type
    this.loadFormData();
  }

  selectLot(index: number): void {
    if (this.selectedLotIndex === index) return;
    
    // Save current form data before switching
    this.saveCurrentFormData();
    
    // Switch lot
    this.selectedLotIndex = index;
    this.showEditButton = this.lots[index].hasEntry; // Show edit button if lot has existing data
    // Load form data for new lot
    this.loadFormData();
  }

  addLot(lotData:any): void {
    if(lotData){
       const newLot: Lot = {
          hasEntry: true,
          lotFormData: lotData       
        };
        this.showEditButton = true;
          this.lots.push(newLot);
    }else{
      const newLot: Lot = {
      hasEntry: false,
      lotFormData: this.getDefaultFormData(),
      
    };
      this.showEditButton = false;
      this.lots.push(newLot);
    }
   
  
    this.selectedLotIndex = this.lots.length - 1;
    
    // Load the new lot's form data
    this.loadFormData();
  }

  deleteLot(index: number): void {
    if (this.lots.length === 0 || index < 0 || index >= this.lots.length) {
      return;
    }

    // Remove lot from array
    this.lots.splice(index, 1);

    // Adjust selectedLotIndex if needed
    if (this.selectedLotIndex >= this.lots.length) {
      this.selectedLotIndex = Math.max(0, this.lots.length - 1);
    }

    // Load form data for the new selected lot (or reset if no lots remain)
    if (this.lots.length > 0) {
      this.loadFormData();
    } else {
      this.analysisForm.reset();
      this.fileArray = [];
    }
  }

  saveCurrentFormData(): void {
    if (this.lots.length === 0) return;
    
    const currentLot = this.lots[this.selectedLotIndex];
    if (!currentLot) return;
    const formData = this.analysisForm.value;
    const existingLotData: any = currentLot.lotFormData || {};

    currentLot.lotFormData = {
      ...existingLotData,
      reportingDate: formData.reportingDate,
      startDate: formData.startDate,
      endDate: formData.endDate,
      remarks: formData.remarks,
      fineQuality: {
        ...(existingLotData.fineQuality || {}),
        quantity: formData.nbsfQuantity,
        totalFe: formData.nbsfTotalFe,
        silica: formData.nbsfSilica,
        alumina: formData.nbsfAlumina,
        phosphorus: formData.nbsfPhosphorus,
        sulfur: formData.nbsfSulfur,
        lossOnIgnition: formData.nbsfLossOnIgnition,
        moistureContent: formData.nbsfMoistureContent,
        oversize6p3Mm: formData.oversize6p3Mm,
        oversize4Mm: formData.oversize4Mm,
        oversize1Mm: formData.oversize1Mm,
        oversize0p5Mm: formData.oversize0p5Mm,
        oversize0p25Mm: formData.oversize0p25Mm,
        oversize0p15Mm: formData.oversize0p15Mm,
        minus0p15Mm: formData.minus0p15Mm,
      },
      lumpQuality: {
        ...(existingLotData.lumpQuality || {}),
        quantity: formData.nbslQuantity,
        totalFe: formData.nbslTotalFe,
        silica: formData.nbslSilica,
        alumina: formData.nbslAlumina,
        phosphorus: formData.nbslPhosphorus,
        sulfur: formData.nbslSulfur,
        lossOnIgnition: formData.nbslLossOnIgnition,
        moistureContent: formData.nbslMoistureContent,
        oversize31p5Mm: formData.oversize31p5Mm,
        oversize25Mm: formData.oversize25Mm,
        oversize20Mm: formData.oversize20Mm,
        undersize6p3Mm: formData.undersize6p3Mm,
        oversize15Mm: formData.oversize15Mm,
        oversize10Mm: formData.oversize10Mm,
        oversize8Mm: formData.oversize8Mm,
        oversize6p3Mm: formData.oversize6p3Mm_nbsl,
      },
     documents: this.fileArray,
      files: this.fileArray,
    } as any;
    
    
    // Mark as having entry if any field has a value
    const hasData = Object.values(formData).some(val => val !== null && val !== '');
    if (hasData || this.fileArray.length > 0) {
      currentLot.hasEntry = true;
    }
    this.currentLotData = currentLot.lotFormData;
  }

  loadFormData(): void {
    if (this.lots.length === 0) return;
    
    const currentLot = this.lots[this.selectedLotIndex];
    if (!currentLot) return;
    
    const formData = currentLot.lotFormData;
   
    this.formData=formData;
    // Load form values
    this.analysisForm.patchValue({
      reportingDate: this.formData?.reportingDate ,
      startDate: this.formData?.startDate,
      endDate: this.formData?.endDate,
      nbslQuantity:  this.formData?.lumpQuality?.quantity || null,
      nbsfQuantity: this.formData?.fineQuality?.quantity || null,
      nbslTotalFe: this.formData?.lumpQuality?.totalFe || null,
      nbslSilica: this.formData?.lumpQuality?.silica || null,
      nbslAlumina: this.formData?.lumpQuality?.alumina || null,
      nbsfTotalFe: this.formData?.fineQuality?.totalFe || null,
      nbsfSilica: this.formData?.fineQuality?.silica || null,
      nbsfAlumina: this.formData?.fineQuality?.alumina || null,
      nbslPhosphorus:this.formData?.lumpQuality?.phosphorus || null,
      nbslSulfur:this.formData?.lumpQuality?.sulfur || null,
      nbslLossOnIgnition:this.formData?.lumpQuality?.lossOnIgnition || null,
      nbslMoistureContent:this.formData?.lumpQuality?.moistureContent || null,
      nbsfPhosphorus:this.formData?.fineQuality?.phosphorus || null,
      nbsfSulfur:this.formData?.fineQuality?.sulfur || null,
      nbsfLossOnIgnition:this.formData?.fineQuality?.lossOnIgnition || null,
      nbsfMoistureContent:this.formData?.fineQuality?.moistureContent || null,
      oversize31p5Mm: this.formData?.lumpQuality?.oversize31p5Mm || null,
      oversize25Mm: this.formData?.lumpQuality?.oversize25Mm || null,
      oversize20Mm: this.formData?.lumpQuality?.oversize20Mm || null,
      undersize6p3Mm: this.formData?.lumpQuality?.undersize6p3Mm || null,
      oversize15Mm: this.formData?.lumpQuality?.oversize15Mm || null,
      oversize10Mm: this.formData?.lumpQuality?.oversize10Mm || null,
      oversize8Mm: this.formData?.lumpQuality?.oversize8Mm || null,
      oversize6p3Mm_nbsl: this.formData?.lumpQuality?.oversize6p3Mm|| null,
      oversize6p3Mm: this.formData?.fineQuality?.oversize6p3Mm || null,
      oversize4Mm: this.formData?.fineQuality?.oversize4Mm || null,
      oversize1Mm:this.formData?.fineQuality?.oversize1Mm || null,
      oversize0p5Mm:this.formData?.fineQuality?.oversize0p5Mm || null,
      oversize0p25Mm:this.formData?.fineQuality?.oversize0p25Mm || null,
      oversize0p15Mm:this.formData?.fineQuality?.oversize0p15Mm || null,
      minus0p15Mm:this.formData?.fineQuality?.minus0p15Mm || null,
      remarks: this.formData?.remarks || null,
      
    });
    
    // Load files
    this.fileArray = this.formData.documents || [];
    this.currentLotData = currentLot.lotFormData;
    this.enableLoader= false;
  }

  save(): void {
    this.isSubmitted = true;
    this.enableLoader = true;
    if (this.analysisForm.invalid) {
      this.analysisForm.markAllAsTouched();
      return;
    }
    console.log(this.showEditButton);
    // Save current form data before saving
    this.saveCurrentFormData();
    
    // TODO: wire up save API call
   
    let formdata = this.analysisForm.value;
     let SaveData = {
      "guid": "",
      "startDate": formdata.startDate,
      "endDate": formdata.endDate,
      "reportingDate": formdata.reportingDate,
      "remarks": formdata.remarks,
      "fineQuality": {
          "quantity": formdata.nbsfQuantity,
          "totalFe": formdata.nbsfTotalFe,
          "silica": formdata.nbsfSilica,
          "alumina": formdata.nbsfAlumina,
          "phosphorus": formdata.nbsfPhosphorus,
          "sulfur": formdata.nbsfSulfur,
          "lossOnIgnition": formdata.nbsfLossOnIgnition,
          "moistureContent": formdata.nbsfMoistureContent,
          "oversize6p3Mm": formdata.oversize6p3Mm,
          "oversize4Mm": formdata.oversize4Mm,
          "oversize1Mm": formdata.oversize1Mm,
          "oversize0p5Mm": formdata.oversize0p5Mm,
          "oversize0p25Mm": formdata.oversize0p25Mm,
          "oversize0p15Mm": formdata.oversize0p15Mm,
          "minus0p15Mm": formdata.minus0p15Mm
      },
      "lumpQuality": {
          "quantity": formdata.nbslQuantity,
          "totalFe": formdata.nbslTotalFe,
          "silica": formdata.nbslSilica,
          "alumina": formdata.nbslAlumina,
          "phosphorus": formdata.nbslPhosphorus,
          "sulfur": formdata.nbslSulfur,
          "lossOnIgnition": formdata.nbslLossOnIgnition,
          "moistureContent": formdata.nbslMoistureContent,
          "oversize31p5Mm": formdata.oversize31p5Mm,
          "oversize25Mm": formdata.oversize25Mm,
          "oversize20Mm": formdata.oversize20Mm,
          "oversize15Mm": formdata.oversize15Mm,
          "oversize10Mm": formdata.oversize10Mm,
          "oversize8Mm": formdata.oversize8Mm,
          "undersize6p3Mm": formdata.undersize6p3Mm,
          "oversize6p3Mm": formdata.oversize6p3Mm_nbsl
      },
      "files": {
          "files":this.fileArray
      }
    }
    if(this.showEditButton===true){ 
      this.callApiToSaveData(SaveData);
    }else if(this.showEditButton===false){
      SaveData.guid = this.currentLotData?.guid;
      
      this.callApiToSaveData(SaveData);
    }   

  }
  callApiToSaveData(SaveData:any){
    this.customProfileService.saveLot(SaveData,this.productCode).subscribe({
      next: (response:any) => {
        // console.log('Save successful:', response);
        this.showEditButton = true; // Show edit button after first save
        this.toastrService.show(response.success);
        this.attachments = this.fileArray; // Update attachments with newly uploaded files
       this.ngOnInit();
       this.router.navigateByUrl(this.router.url); // Refresh the page to get updated data
        
         this.enableLoader = false;
         
      },
      error: (error:any) => {
       // console.error('Save failed:', error);       
        this.enableLoader = false;
      }
    });
  }
  isFieldInvalid(controlName: string): boolean {
    const control = this.analysisForm.get(controlName);
    if (!control) {
      return false;
    }
    return !!(control.invalid && (control.touched || this.isSubmitted));
  }

  hasFormError(errorKey: string): boolean {
    const form = this.analysisForm;
    return !!(form.errors?.[errorKey] && (form.touched || this.isSubmitted));
  }

  private dateRangeValidator = (control: AbstractControl): ValidationErrors | null => {
    const startValue = control.get('startDate')?.value;
    const endValue = control.get('endDate')?.value;
    if (!startValue || !endValue) {
      return null;
    }

    const startDate = this.normalizeDate(startValue);
    const endDate = this.normalizeDate(endValue);
    if (!startDate || !endDate) {
      return null;
    }

    return endDate >= startDate ? null : { invalidDateRange: true };
  };

  private normalizeDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const parts = value.split('/');
      if (parts.length !== 3) {
        return null;
      }
      const day = Number(parts[0]);
      const month = Number(parts[1]);
      const year = Number(parts[2]);
      if (!day || !month || !year) {
        return null;
      }
      return new Date(year, month - 1, day);
    }

    if (value.year && value.month && value.day) {
      return new Date(value.year, value.month - 1, value.day);
    }

    return null;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDropSuccess(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      this.onFileChange(event.dataTransfer.files);
    }
  }

  onFileChange(files: FileList): void {
    this.fileLoading = true;
    if (!files?.length) { return; }
    const file = files[0];
    const allowed = ['application/pdf', 'image/jpeg', 'image/png',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (!allowed.includes(file.type) || file.size > 10485760) {
      this.uploadErr = true;
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      this.fileArray.push({
        name: file.name,
        mime: file.type,
        size: file.size.toString(),
        fileInBase64: base64,
        downloadURL: base64
      });
      this.fileLoading = false;
      // Mark lot as having entry when file is uploaded
      if (this.lots[this.selectedLotIndex]) {
        this.lots[this.selectedLotIndex].hasEntry = true;
      }
    };
  }
  reportingDate1:any;
  startDate1:any;
  endDate1:any;
   onDateSelect(event:any) {
    this.reportingDate1  = event;
  }
  onStartDateSelect(event:any) {
    this.startDate1  = event;
  }
  onEndDateSelect(event:any) {
    this.endDate1  = event;
  }
  edit(): void {
    this.showEditButton = false;
  }
  
  removeUploadedAttachment(index: number): void {
    if (index < 0 || index >= this.fileArray.length) {
      return;
    }
    const attachment = this.fileArray[index] || {};

   // const attachmentId = attachment.documentId || attachment.id || attachment.guid;
    const isNewAttachment = !attachment.baseUrl && !attachment.code;
    if (isNewAttachment) {
      this.removeAttachmentFromLocalArray(index);
      return;
    }

    let dataObj = {
      "guid": this.currentLotData?.guid,
      "code": attachment.code 
    }
    this.fileLoading = true;
    this.customProfileService.deleteQualityAttachment(dataObj).subscribe({
      next: (res: any) => {
        this.removeAttachmentFromLocalArray(index);
        this.toastrService.show(res?.success || 'Attachment deleted successfully.');
        this.fileLoading = false;
      },
      error: () => {
        this.fileLoading = false;
        this.translationService.translate('quality.deleteAttachmentfailed').subscribe(res=>{
        this.toastrService.show(res);
      })
      }
    });
  }

  private removeAttachmentFromLocalArray(index: number): void {
    this.fileArray.splice(index, 1);

    const currentLot = this.lots[this.selectedLotIndex];
    if (currentLot?.lotFormData) {
      currentLot.lotFormData.documents = [...this.fileArray];
      currentLot.lotFormData.files = [...this.fileArray];
    }

    this.attachments = [...this.fileArray];
  }
    private getDateYYYYMMDD(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }
   donwloadReport(reportType:string){
    let toastshown = false;
    this.enableLoader = true;
      this.customProfileService.exportReport(reportType,null,this.id).subscribe(
        (response:any) => {
          if (response.status == 'success') {
            const ref = document.createElement('a');
            ref.href = `data:application/xlsx;base64,${response.code}`;
            if (reportType === 'quality_report') {
              ref.download = `CCIC_Inspection_Quality_Daily_Report-${this.getDateYYYYMMDD()}.xlsx`;
            } 
            ref.click();
            this.enableLoader = false;
            this.translationService
              .translate('shipment.downloaddoc')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
          } else {
            this.enableLoader = false;
            this.toastrService.show(response.status);
          }
        },
        (err:any) => {
          this.enableLoader = false;
          // this.toastrService.show('Download unsuccessful, please contact support team.');
          this.translationService
            .translate('shipment.downloadunsuccess')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
              }
            });
        },
      );
  }
 openInvoices(data: any): void { 
        const modalref = this.modalService.open(AttachInvoiceComponent, {
              centered: true,
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
            });
            modalref.componentInstance.display='invoices';
            modalref.componentInstance.batchData = data;
            modalref.componentInstance.useCaseType ='QUALITYINVOICE_UC3';
      }
}

